/* eslint-disable */
import axios from 'axios'; //引入axios
import store from '@/store'
import { encrypt } from '@/helpers/util.js'
const encryptionUrl = 'wechat/getDetailsInfo'
export function fetch(options) {
  if(options.method == "get"){
    if(typeof options.params == "object"){
      options.params.openid = store.state.userInfo.openid;
      // options.params.openid = '79oi0gLj4X2s-oLPP8cLuZSh3tpJNc31-4';
      // options.params.openid = '821obFhg0WG0x-Xnk_6jsIJKPhfQ_1o66-5';
    }else{
      options.params ={
       openid:store.state.userInfo.openid
      //  openid:'79oi0gLj4X2s-oLPP8cLuZSh3tpJNc31-4'
      }
    }

  }
  if(options.method == "post"){
    if(typeof options.data == "object"){
      options.data.openid = store.state.userInfo.openid;
      if(options.url === '/api/wechat/summary/ai'){
         delete options.data.openid
         options.data.openId = store.state.userInfo.openid;
      }
      // options.data.openid = '79oi0gLj4X2s-oLPP8cLuZSh3tpJNc31-4';
    }else{
      options.data ={
        openid:store.state.userInfo.openid   
        // openid:'79oi0gLj4X2s-oLPP8cLuZSh3tpJNc31-4'
      }
    }
  }
	return new Promise((resolve, reject) => {
    let head = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    if(options.istoken){
      head['token'] = 'bG9ncHJvY2Vzcw=='
    }
    if(options.url.includes(encryptionUrl)){
      const time = (new Date()).valueOf()
      const logintoken = encrypt('yqms-' + time.toString().substr(0, 10))
      head['accessToken'] = logintoken
    }
		const instance = axios.create({ //instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
			//所有的请求都会带上这些配置，比如全局都要用的身份信息等。
			headers: head,
			timeout: 120 * 1000 // 120秒超时
		});
		instance(options)
			.then(response => { //then 请求成功之后进行什么操作
				resolve(response); //把请求到的数据发到引用请求的地方
			})
			.catch(error => {
				if(error.message.indexOf('401') > -1) {
					localStorage.clear();
				}
        reject(error);//失败执行函数
			});
	});
}
